import { render, staticRenderFns } from "./ved.vue?vue&type=template&id=863bbc9a&scoped=true&"
import script from "./ved.vue?vue&type=script&lang=js&"
export * from "./ved.vue?vue&type=script&lang=js&"
import style0 from "./ved.vue?vue&type=style&index=0&id=863bbc9a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863bbc9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('863bbc9a')) {
      api.createRecord('863bbc9a', component.options)
    } else {
      api.reload('863bbc9a', component.options)
    }
    module.hot.accept("./ved.vue?vue&type=template&id=863bbc9a&scoped=true&", function () {
      api.rerender('863bbc9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/ved/ved.vue"
export default component.exports